import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    ma: null, //string, optional // Mã chương trình
    co_hieu_luc: null, //boolean, optional // Cho biết chương trình có hiệu lực hay không
    ten: { //object, optional // Tên chương trình
        vi: null, //string, optional // Tên chương trình tiếng Việt
        en: null, //string, optional // Tên chương trình tiếng Anh
    },
    noi_dung: { //object, optional // Nội dung chương trình
        vi: null, //string, optional // Nội dung chương trình tiếng Việt
        en: null, //string, optional // Nội dung chương trình tiếng Anh
    },
    ap_dung: [], //array of object, optional // Áp dụng cho đối tượng nào
        //loai_doi_tuong: string, optional // Loại đối tượng với các giá trị hợp lệ: tour_guide|customer|place
        //link_survey: string, optional // Link survey
    bat_dau: null, //datetime, optional // Thời điểm bắt đầu của chương trình
    ket_thuc: null, //datetime, optional // Thời điểm kết thúc của chương trình
    
};

// validation form
model.validForm = {
    ma: [ValidService.required], //string, optional // Mã chương trình
    co_hieu_luc: [], //boolean, optional // Cho biết chương trình có hiệu lực hay không
    ten: { //object, optional // Tên chương trình
        vi: [ValidService.required], //string, optional // Tên chương trình tiếng Việt
        en: [ValidService.required], //string, optional // Tên chương trình tiếng Anh
    },
    noi_dung: { //object, optional // Nội dung chương trình
        vi: [], //string, optional // Nội dung chương trình tiếng Việt
        en: [], //string, optional // Nội dung chương trình tiếng Anh
    },
    ap_dung: [], //array of object, optional // Áp dụng cho đối tượng nào
        //loai_doi_tuong: string, optional // Loại đối tượng với các giá trị hợp lệ: tour_guide|customer|place
        //link_survey: string, optional // Link survey
    bat_dau: [], //datetime, optional // Thời điểm bắt đầu của chương trình
    ket_thuc: [], //datetime, optional // Thời điểm kết thúc của chương trình

};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    ap_dung: {
        loai_doi_tuong: null, //string, optional, enum(tour_guide, customer, place) // Loại đối tượng với các giá trị hợp lệ: tour_guide|customer|place
        link_survey: null, //string, optional // Link survey
    }
};

// validation các form khác
model.validFormOther = {
    ap_dung: {
        loai_doi_tuong: [ValidService.required], //string, optional, enum(tour_guide, customer, place) // Loại đối tượng với các giá trị hợp lệ: tour_guide|customer|place
        link_survey: [ValidService.required], //string, optional // Link survey
    }
};

model.loaiDoiTuong = [{
    code: "tour_guide",
    text: "Hướng dẫn viên"
},
// {
//     code: "customer",
//     text: "Khách du lịch"
// },
{
    code: "place",
    text: "Điểm đến"
},
];

model.hieuLuc = [{
    code: "true",
    text: "Có"
},
{
    code: "false",
    text: "Không"
},
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thoi_diem_tao", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            ma: "",
            co_hieu_luc: "", 
            'ap_dung.loai_doi_tuong': "",
            bat_dau: "", 
            ket_thuc: "",         
            nguoi_tao_id: ""
        },
        valid: {
            ma: [],
            co_hieu_luc: [], 
            'ap_dung.loai_doi_tuong': [],
            bat_dau: [], 
            ket_thuc: [],         
            nguoi_tao_id: []
        },
        operator: {
            ma: ":regex_i:",
            // 'ten.vi': ":regex_i:", //:regex:, $vn_text=Viêt nam
            // 'ten.en': ":regex_i:"
            bat_dau: ":in_that_day:", 
            ket_thuc: ":in_that_day:",
        }
    }
};

export default model;